import { Component } from '@angular/core';
import { FormlyFieldMultiCheckbox } from '@ngx-formly/material/multicheckbox';

@Component({
  selector: 'formly-indeterminate-checkbox',
  templateUrl: './indeterminate-checkbox.component.html',
  styleUrls: ['./indeterminate-checkbox.component.scss'],
})
export class IndeterminateCheckboxComponent extends FormlyFieldMultiCheckbox {

  allSelected: boolean;
  someSelected: boolean;

  toggleSelectAll( selected: boolean ) {
    this.checkboxes.forEach( (box, index) => {
      if(index > 0) {
        box.change.emit({
          source: box,
          checked: selected
        });
      }
    });
    this.allSelected = selected;
    this.someSelected = false;
  }

  onChange(value, checked: boolean) {
    FormlyFieldMultiCheckbox.prototype.onChange.apply(this, arguments);
    this.updateSelection();
  }

  updateSelection() {
    // @ts-ignore
    const length = this.to.options?.length || 0;
    const val = this.to.type === 'array' ?
      this.value :
      this.value.filter( opt => opt.value );

    this.someSelected = val.length > 0 && val.length !== length;
    this.allSelected = val.length === length;
  }

}
